<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-gavel</v-icon>{{$t('contract.contracttypes')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ContracttypeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ContracttypeForm from '../../components/contracttype/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Contracttype';

const { mapFields } = createHelpers({
  getterType: 'contracttype/getField',
  mutationType: 'contracttype/updateField'
});

export default {
  name: 'ContracttypeCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ContracttypeForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('contracttype', ['create', 'reset'])
  }
};
</script>
